module.exports = __webpack_public_path__ + "static/img/kyl.d166c45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kyl.jpg
// module id = BzEZ
// module chunks = 1